"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doSearch = exports.updateAddressBar = exports.getCurrentState = void 0;
var effects_1 = require("redux-saga/effects");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var WindowApi_1 = require("@/api/browser/WindowApi");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var SearchApi_1 = require("@/api/remote/public/SearchApi");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var HeadingAction_1 = require("@/pages/search/actions/sfilter/HeadingAction");
var BreadcrumbAction_1 = require("@/pages/search/actions/sfilter/BreadcrumbAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var DinfoAction_1 = require("@/pages/search/actions/sfilter/DinfoAction");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var SearchAction_1 = require("@/pages/search/actions/SearchAction");
exports.getCurrentState = function (state) {
    var newState = JSON.parse(JSON.stringify(state));
    newState.history = [];
    return newState;
};
exports.updateAddressBar = function () {
    var state, pageSize, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [4 /*yield*/, effects_1.select(GlobalCallSaga_1.getResultPageSize)];
            case 2:
                pageSize = _a.sent();
                return [4 /*yield*/, effects_1.call(SearchApi_1.transformRequestToUrl, state, pageSize)];
            case 3:
                url = _a.sent();
                if (!url) return [3 /*break*/, 6];
                if (window.location.pathname.toLowerCase() === url.toLowerCase())
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.setAddressBar, url)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onAddressBarUpdate())];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
};
exports.doSearch = function (searchQuery, viewport) {
    var sfilterType, searchResponse, newResultPage, heading, results, pageTotal, page, analyticData, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sfilterType = SfilterTypeGroup_1.ListingPurposeType.toSfilterType(searchQuery.listingTypeId);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 17, , 19]);
                if ("" + Number(searchQuery.keyword) === searchQuery.keyword) {
                    searchQuery.geoString = '';
                }
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setLoading(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(SearchApi_1.searchQueryApi, searchQuery)];
            case 3:
                searchResponse = _a.sent();
                return [4 /*yield*/, effects_1.call(searchResponseToResultPage_1.searchResponseToResultPage, searchResponse, sfilterType)];
            case 4:
                newResultPage = _a.sent();
                heading = newResultPage.heading;
                results = newResultPage.results;
                pageTotal = newResultPage.pageTotal;
                page = newResultPage.page;
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.checkScrollEnd())];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setResultPage(results, page, pageTotal))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setResultEstatePhase(newResultPage.estatePhase))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.setIsMap(searchQuery.isMap))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HeadingAction_1.default.setHeading(heading))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(BreadcrumbAction_1.default.setSearchType(sfilterType))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ResultAction_1.default.onUpdateLastItemPosition())];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.updateSlider)];
            case 12:
                _a.sent();
                return [4 /*yield*/, effects_1.put(DinfoAction_1.default.onUpdateDistrictInfo(searchQuery.district.split(',').filter(function (it) { return it; }).map(function (it) { return Number(it.trim().toLowerCase()); })))];
            case 13:
                _a.sent();
                if (!(searchResponse.aggregatedData && searchResponse.aggregatedData.length)) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.handleResponse(searchResponse, viewport))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [4 /*yield*/, effects_1.spawn(exports.updateAddressBar)];
            case 16:
                _a.sent();
                if (searchResponse.result && searchResponse.result.externalProviders) {
                    analyticData = { data: { externalProviders: searchResponse.result.externalProviders } };
                }
                return [3 /*break*/, 19];
            case 17:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiSearchError'))];
            case 18:
                _a.sent();
                console.log(e_1);
                return [3 /*break*/, 19];
            case 19: return [4 /*yield*/, effects_1.put(ResultAction_1.default.setLoading(false))];
            case 20:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchAction_1.default.clearTextImages())];
            case 21:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
